var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolutionColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6303 66.8101H56.1803M42.2603 73.5601H55.4703M41.1703 70.2001H56.4903M48.8303 31.8101C44.569 31.818 40.4846 33.515 37.4724 36.5292C34.4601 39.5433 32.7656 43.6287 32.7603 47.8901C32.7535 50.0632 33.1938 52.2144 34.054 54.21C34.9142 56.2056 36.1758 58.0029 37.7603 59.4901C38.0088 59.7677 38.1598 60.1188 38.1903 60.4901V61.3001C38.1902 62.3619 38.4668 63.4055 38.9929 64.3278C39.519 65.2502 40.2763 66.0196 41.1903 66.5601H41.2703V71.2301C41.273 72.2198 41.4707 73.1992 41.8521 74.1125C42.2336 75.0257 42.7913 75.8548 43.4935 76.5523C44.1956 77.2498 45.0284 77.802 45.9441 78.1774C46.8599 78.5528 47.8406 78.744 48.8303 78.7401H49.0003C49.9887 78.744 50.9682 78.5531 51.8827 78.1782C52.7972 77.8033 53.6289 77.2518 54.3301 76.5552C55.0313 75.8586 55.5883 75.0307 55.9693 74.1186C56.3503 73.2066 56.5477 72.2284 56.5503 71.2401V71.2401V66.6401C56.5795 66.65 56.6112 66.65 56.6403 66.6401C57.5439 66.0929 58.2898 65.3205 58.8052 64.3984C59.3205 63.4764 59.5876 62.4363 59.5803 61.3801V60.5701C59.6067 60.1996 59.7543 59.8482 60.0003 59.5701C61.5845 58.0784 62.8456 56.2775 63.7057 54.2787C64.5657 52.28 65.0064 50.126 65.0003 47.9501C65.011 43.6904 63.3332 39.6001 60.3343 36.575C57.3354 33.5499 53.2599 31.8365 49.0003 31.8101H48.8303Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5202 62.75L27.4902 68.79",
    stroke: "#F15C00",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1801 47.4399H18.6401",
    stroke: "#F15C00",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.52 32.1198L27.48 26.0898",
    stroke: "#F15C00",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8301 25.78V17.25",
    stroke: "#F15C00",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1499 32.1198L70.1799 26.0898",
    stroke: "#F15C00",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4902 47.4399H79.0302",
    stroke: "#F15C00",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1802 62.75L70.1802 68.79",
    stroke: "#F15C00",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionColored);
export default __webpack_public_path__ + "static/media/SolutionColored.8a42e738b405a5c257677144100856cb.svg";
export { ForwardRef as ReactComponent };